<template>
	<div class="manage-nfl-playoff-confidence-pool-entry-page">
		<div class="manage-nfl-playoff-confidence-pool-entry-page__content">
			<div class="entry-data" v-if="pool !== null">
				<h3 class="entry-name">{{ entryName }}</h3>
				<p class="info">Select the number of points (1 - 14) you'd like to assign to each playoff team. Every time a team wins a playoff game, you'll receive the corresponding number of points. You can only select each number once. Remember that the first overall seeds each have a bye!</p>
				<button class="save-button" @click="updatePicks" :disabled="alreadySelected.length != picks.length">Save</button>
				<table class="entry-picks">
					<tr class="header-row">
						<th class="seed">Seed</th>
						<th class="team">Playoff Team</th>
						<th class="points">Points</th>
					</tr>
					<tr class="pick-row" v-for="pick in picks" :key="pick.id">
						<td class="seed">{{ pick.team_seed }}</td>
						<td class="team">{{pick.team_name}}</td>
						<td class="points">
							<select  v-model="pick.points">
								<option value="0"></option>
								<option v-for="(pick, index) in picks" :key="index" :value="index+1" :disabled="alreadySelected.includes(index+1)">{{ index + 1 }}</option>
							</select>
						</td>
					</tr>
				</table>
				
			</div>
		</div>

		<div class="popup" v-if="showSaveSuccessfull">
			<div class="popup__content">
				<p class="font-size--medium">Entry Saved Successfully!</p>
				<div class="popup__content--bottom">
					<button class="font-size--medium text-color--secondary" @click="showSaveSuccessfull = false">Close</button>
				</div>	
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations } from 'vuex'
	import axios from '@/axios'

	export default {
		props: [ 'poolId', 'entryId', ],
		data() {
			return {
				pool: null,
				picks: [],
				showSaveSuccessfull: false
			}
		},
		computed: {
			entryName() {
				var userEntry = null
				this.pool.entries.forEach((entry) => {
					if (entry.current_user_entry) {
						userEntry = entry
					}
				})

				var name = ''
				userEntry.entry_users.forEach((user, index) => {
					if (index == 0) {
						name = user.user.name
					} else if (index == userEntry.entry_users.length - 1 && userEntry.entry_users.length > 2) {
						name = name.concat(user.user.name)
					} else {
						name = name.concat(' / ').concat(user.user.name)
					}
				})

				return name
			},
			alreadySelected() {
				var pointsTaken = []
				this.picks.forEach(pick => {
					if (pick.points !== null && pick.points != 0) {
						pointsTaken.push(pick.points)
					}
				})
				return pointsTaken
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			getNflPlayoffConfidencePool() {
				return axios.get('nfl-playoff-confidence-pools/' + this.poolId).then((response) => {
					this.pool = response.data.data
				})
			},
			setPicks() {
				var userEntry = null
				this.pool.entries.forEach((entry) => {
					if (entry.current_user_entry) {
						userEntry = entry
					}
				})		

				var picks = []
				userEntry.picks.forEach((pick) => {
					picks.push({
						id: pick.id,
						team_name: pick.nfl_playoff_participant.nfl_team.location + ' ' + pick.nfl_playoff_participant.nfl_team.nickname,
						team_seed: pick.nfl_playoff_participant.seed,
						points: pick.points
					})
				})
				picks.sort(function(a,b) {
					return a.team_seed - b.team_seed
				})

				this.picks = picks
			},
			updatePicks() {
				this.HTTP_IN_PROGRESS()
				return axios.patch('nfl-playoff-confidence-pools/' + this.poolId + '/nfl-playoff-confidence-pool-entries/' + this.entryId, {picks: this.picks}).then(() => {
					this.getNflPlayoffConfidencePool().then(() => {
						this.setPicks()
						this.showSaveSuccessfull = true
						this.HTTP_FINISHED()
					})
				})
			}
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getNflPlayoffConfidencePool().then(() => {
				this.setPicks()
				this.HTTP_FINISHED()
			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
		},
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/nfl/nfl-playoff-confidence-pool/manageEntry';
</style>